import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import styles from "./styles.module.scss";
import cx from "classnames";
import useAppContext from "../AppContext";
import { AsHtml } from "../../utils/translate";

import NextButton from "../NextButton";

export default function StickyFooter({
  nextButtonProps,
  message = { label: "", className: "" },
  className
}) {
  const { isDisabled } = nextButtonProps;
  const { newQuiz } = useAppContext();

  useEffect(() => {
    const rootElement = document.getElementById("root");
    rootElement.appendChild(containerRef.current);
    return () => {
      rootElement.removeChild(containerRef.current);
    };
  }, []);

  const containerRef = useRef(document.createElement("div"));

  return ReactDOM.createPortal(
    <div
      className={cx(styles.stickyWrapper, className, {
        [styles.wrapperWithMessage]: message
      })}
    >
      <div className={styles.stickyContainer}>
        {nextButtonProps && (
          <NextButton
            tabIndex={0}
            {...nextButtonProps}
            overrideClassName={cx(styles.stickyNext, {
              [styles.disabled]: isDisabled,
              [styles.stickyNextAndroid]: newQuiz.isAndroid
            })}
          />
        )}
      </div>
      {message?.label && (
        <AsHtml
          value={message?.label}
          className={cx(message?.className, styles.message)}
        />
      )}
      <label className={styles.hidden} htmlFor="g-recaptcha-response-100000">
        Recaptcha
      </label>
    </div>,
    containerRef.current
  );
}
